import { fetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  IContentLibraryIndirectTaxAddressStatesParams,
  IContentLibraryResponse,
} from './types';

// Fetch the valid state/subdivision options for a country's address from the
// Content Library. Returns SWR's { data, error, isLoading, mutate }. Pass `null`
// to stay idle (e.g. before a country is selected). Params are encoded in the SWR
// key, so the fetcher receives them already non-null (no guard needed) and SWR
// dedupes identical (corporationId, country) requests across components.
export function useContentLibraryIndirectTaxAddressStates(
  params: IContentLibraryIndirectTaxAddressStatesParams | null
) {
  const { data, mutate, error, isLoading } = useSWR<IContentLibraryResponse>(
    params
      ? ([
          'content-library/indirect-tax-address-states',
          params.corporationId,
          params.country,
        ] as const)
      : null,
    async ([endpoint, corporationId, country]) => {
      const response = await fetcher(endpoint, {
        method: 'POST',
        body: { corporationId, country },
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message ||
            'Failed to fetch address states from content library'
        );
      }
      return response.json();
    }
  );

  return { data, mutate, error, isLoading };
}
